export default {
  header: 'An employee needs to enter the code',
  error_codes: {
    403: 'Wrong Passcode.',
    default: 'Something unexpected happened. Please try again or check your internet connection.',
  },
};
